"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FELT: function() {
        return FELT;
    },
    DYNAMISKFELT: function() {
        return DYNAMISKFELT;
    },
    DYNAMISKGRUPPE: function() {
        return DYNAMISKGRUPPE;
    },
    REPETERENDEFELT: function() {
        return REPETERENDEFELT;
    },
    FELTGRUPPE: function() {
        return FELTGRUPPE;
    },
    KORTTYPE: function() {
        return KORTTYPE;
    },
    FELT_MED_EGENSKAPER: function() {
        return FELT_MED_EGENSKAPER;
    },
    EGENSKAP_BELOEP: function() {
        return EGENSKAP_BELOEP;
    },
    EGENSKAP_BELOEP_I_VALUTA: function() {
        return EGENSKAP_BELOEP_I_VALUTA;
    },
    EGENSKAP_TRYGDE_ELLER_SKATTEMESSIG_UNNTAK: function() {
        return EGENSKAP_TRYGDE_ELLER_SKATTEMESSIG_UNNTAK;
    },
    EGENSKAP_VALUTAKODE: function() {
        return EGENSKAP_VALUTAKODE;
    },
    EGENSKAP_METODE_VED_DOBBELTBESKATNING: function() {
        return EGENSKAP_METODE_VED_DOBBELTBESKATNING;
    },
    TALL: function() {
        return TALL;
    },
    DESIMALTALL_TO_DESIMALER: function() {
        return DESIMALTALL_TO_DESIMALER;
    },
    DESIMALTALL: function() {
        return DESIMALTALL;
    },
    PROSENT: function() {
        return PROSENT;
    },
    STORT_TALL: function() {
        return STORT_TALL;
    },
    erFelt: function() {
        return erFelt;
    },
    erFeltMedEgenskaper: function() {
        return erFeltMedEgenskaper;
    },
    erDynamiskFelt: function() {
        return erDynamiskFelt;
    },
    erTall: function() {
        return erTall;
    },
    mapObject: function() {
        return mapObject;
    },
    flatten: function() {
        return flatten;
    },
    flatListe: function() {
        return flatListe;
    },
    filtrerOpsjonerPaaKodetillegg: function() {
        return filtrerOpsjonerPaaKodetillegg;
    }
});
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _isEmpty = /*#__PURE__*/ _interop_require_default(require("lodash/isEmpty"));
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var FELT = "felt";
var DYNAMISKFELT = "dynamiskfelt";
var DYNAMISKGRUPPE = "dynamiskgruppe";
var REPETERENDEFELT = "repeterendefelt";
var FELTGRUPPE = "feltgruppe";
var KORTTYPE = "korttype";
var FELT_MED_EGENSKAPER = "feltMedEgenskaper";
var EGENSKAP_BELOEP = "beloep";
var EGENSKAP_BELOEP_I_VALUTA = "beloepIValuta";
var EGENSKAP_TRYGDE_ELLER_SKATTEMESSIG_UNNTAK = "trygdeEllerSkattemessigUnntak";
var EGENSKAP_VALUTAKODE = "valutakode";
var EGENSKAP_METODE_VED_DOBBELTBESKATNING = "metodeVedDobbeltbeskatning";
var TALL = "tall";
var DESIMALTALL_TO_DESIMALER = "desimaltall";
var DESIMALTALL = "desimaltallVisAlt";
var PROSENT = "prosent";
var STORT_TALL = "stortTall";
var erFelt = function(def) {
    return def.type === FELT;
};
var erFeltMedEgenskaper = function(def) {
    return def.type === FELT_MED_EGENSKAPER;
};
var erDynamiskFelt = function(def) {
    return def.type === DYNAMISKFELT;
};
var erTall = function(feltDef) {
    return [
        TALL,
        DESIMALTALL_TO_DESIMALER,
        DESIMALTALL,
        PROSENT,
        STORT_TALL
    ].includes((0, _get.default)(feltDef, "transformer.id"));
};
var mapObject = function() {
    var toMap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(a) {
        return a;
    };
    var ret = {};
    f(Object.entries(toMap)).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        ret[key] = value;
    });
    return ret;
};
var flatten = function(list) {
    return list.reduce(function(a, b) {
        return a.concat(Array.isArray(b) ? flatten(b) : b);
    }, []);
};
var flatListe = function(type, liste) {
    var unntaksliste = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (liste) {
        return _to_consumable_array(liste).concat(_to_consumable_array(flatten(liste.filter(function(felt) {
            return !unntaksliste.includes(felt.type);
        }).map(function(felt) {
            return felt.barnliste ? flatListe(type, felt.barnliste, unntaksliste) : [];
        })))).filter(function(felt) {
            return felt.type === type;
        });
    }
    return [];
};
var filtrerOpsjonerPaaKodetillegg = function(feltdefinisjon) {
    var visningsdata = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, kodeliste = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var opsjon = feltdefinisjon.opsjon;
    if ((0, _get.default)(opsjon, "kodetilleggfilter") && !(0, _isEmpty.default)(visningsdata)) {
        var _opsjon_kodetilleggfilter = opsjon.kodetilleggfilter, kodetilleggfilter = _opsjon_kodetilleggfilter === void 0 ? [] : _opsjon_kodetilleggfilter;
        var verdier = opsjon.verdier.filter(function(verdi) {
            if (verdi === "") {
                return true;
            }
            return kodetilleggfilter.every(function(param) {
                var kodetillegg = param.kodetillegg, kort = param.kort, felt = param.felt;
                var forekomster = visningsdata[kort];
                var liste = (0, _get.default)(kodeliste, [
                    verdi,
                    kodetillegg
                ], []).map(function(v) {
                    return v.trim();
                });
                if ((0, _isEmpty.default)(liste) || !forekomster.some(function(forekomst) {
                    return forekomst[felt];
                })) {
                    return true;
                }
                return forekomster.some(function(forekomst) {
                    return liste.includes(forekomst[felt]);
                });
            });
        });
        return _object_spread_props(_object_spread({}, feltdefinisjon), {
            opsjon: _object_spread_props(_object_spread({}, opsjon), {
                verdier: verdier
            })
        });
    }
    return feltdefinisjon;
};
